var map = {
	"./1.jpg": 4196,
	"./2.jpg": 3907,
	"./3.jpg": 150,
	"./4.jpg": 9997,
	"./5.jpg": 5104,
	"./6.jpg": 2479,
	"./7.jpg": 770,
	"./8.jpg": 1609,
	"./9.jpg": 4732
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6486;